import { styled } from '@mui/material/styles';
import { DialogContentText, Paper } from '@mui/material';

export const RejectDialogPaper = styled(Paper)({
  maxWidth: 400,
  width: '100%'
});

export const RejectDialogText = styled(DialogContentText)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
